<div class="date">{{ 'report.dateState' | loc }}: {{ date | lDate: 'dtShort' }}</div>
